//TODO cleanup code - implement as a controlled form && use custom inputs

import React from 'react';
import { useState } from 'react';
import { Card, Row, Col, Form, Alert } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '../UI/button';
import { resetPassword } from '../../services/authentication.service';
import withAlert from '../../HOCs/withAlert';
import { ResetPasswordProps } from '../types/reset-password-props';

export interface ResetPasswordModel {
  password: string;
  passwordConfirm: string;
  passwordResetToken: string;
}

function ResetPassword({
  error = '',
  setError,
  message = '',
  setMessage
}: ResetPasswordProps) {
  const { token } = useParams<{ token: string }>();
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (password !== passwordConfirm) {
      setError('Passwords do not match');
      setMessage('');
      return;
    }

    try {
      const resetPasswordModel: ResetPasswordModel = {
        password: password,
        passwordConfirm: passwordConfirm,
        passwordResetToken: token || ''
      };
      const success = await resetPassword(resetPasswordModel);
      if (success) {
        setMessage('Password reset successfully');
        navigate('/login'); // Redirect to login page after successful reset
      } else {
        setError('Failed to reset password');
        setMessage('');
      }
    } catch (err) {
      setError('An error occurred while resetting the password');
      setMessage('');
    }
  };

  return (
    <div className='login w-100'>
      <Row className='g-0 justify-content-md-center'>
        <Col
          md='6'
          className='bg-border-color-gray position-relative'
        >
          <Card.Img
            src='https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/img1.webp'
            alt='login form'
            className='w-100 h-100 object-fit-cover position-absolute'
            style={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0
            }}
          />
        </Col>
        <Col
          md='6'
          className='d-flex align-items-center justify-content-center position-relative overflow-hidden min-vh-100'
        >
          <div className='gradient-bg-login'></div>
          <div
            style={{
              maxWidth: '440px',
              width: '100%',
              padding: '3rem 20px 5rem'
            }}
          >
            <div className='d-flex flex-column'>
              <div className='d-flex flex-column text-center'>
                <span className='h1 fw-bold'>
                  Travel
                  <span className='text-primary'>Hearts</span>
                </span>
                <h3 className='fw-bold'>Reset Password</h3>
              </div>
              {error && <Alert variant='danger'>{error}</Alert>}
              {message && <Alert variant='success'>{message}</Alert>}
              <Form
                style={{ marginTop: '32px' }}
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
              >
                <Form.Group
                  style={{ marginBottom: '20px' }}
                  controlId='passwordInput'
                >
                  <Form.Label>New Password</Form.Label>
                  <Form.Control
                    type='password'
                    placeholder='Enter here'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength={8}
                  />
                </Form.Group>
                <Form.Group
                  style={{ marginBottom: '24px' }}
                  controlId='passwordConfirmInput'
                >
                  <Form.Label>Confirm New Password</Form.Label>
                  <Form.Control
                    type='password'
                    placeholder='Enter here'
                    value={passwordConfirm}
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                    required
                    minLength={8}
                  />
                </Form.Group>
                <Button
                  type='submit'
                  className='font-libre'
                  width='full'
                  color='dark'
                  size='md'
                  fontSize='sm'
                  fontFamily='libre'
                >
                  Reset Password
                </Button>
                <div
                  className='d-flex w-100 justify-content-center align-items-center'
                  style={{ gap: '12px', margin: '24px 0 20px' }}
                >
                  <a
                    href='/forgot-password-email'
                    className='g-col-6 text-dark-2 fs-7 text-decoration-underline'
                  >
                    Send a new reset link
                  </a>
                  <a
                    href='/login'
                    className='g-col-6 text-primary fw-bold font-libre fs-7 text-decoration-underline'
                  >
                    Go back to log in
                  </a>
                </div>
              </Form>
            </div>
          </div>
          <p
            className='position-absolute position-x-center font-libre fs-7 fw-bold text-dark-2'
            style={{ bottom: '32px' }}
          >
            © Travel Hearts 2024
          </p>
        </Col>
      </Row>
    </div>
  );
}

export default withAlert(ResetPassword);
